import * as Sentry from '@sentry/react';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, Firestore, doc, getDoc } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { FIREBASE_CONFIG, USE_EMULATORS } from '../config';

let app: FirebaseApp | undefined;
let db: Firestore | undefined;
let storage: FirebaseStorage | undefined;

try {
  app = initializeApp(FIREBASE_CONFIG);
  db = getFirestore(app);
  storage = getStorage(app);

  if (USE_EMULATORS) {
    connectFirestoreEmulator(db, 'localhost', 8080);
  }

  // Warm up the Firestore WebSocket connection early
  if (db) {
    getDoc(doc(db, '_warmup', '_')).catch(() => {});
  }
} catch (error) {
  console.error('Firebase initialization failed:', error);
  Sentry.captureException(error);
}

export { db, storage };
